import React from 'react';
import { motion } from 'framer-motion';
export function Roadmap() {
  return <section className="py-24 border-b border-stone-300" data-id="element-1586">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1587">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1588">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1589">
            Roadmap
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-6 max-w-3xl" data-id="element-1590">
            From instant quotes to industry intelligence
          </h2>

          <p className="text-lg text-stone-600 leading-relaxed mb-16 max-w-2xl" data-id="element-1591">
            Own the pipe, own the data. BlockQuote builds the infrastructure
            today to power the intelligence layer of tomorrow.
          </p>

          {/* Timeline */}
          <div className="border border-stone-300" data-id="element-1592">
            <div className="grid grid-cols-1 md:grid-cols-4" data-id="element-1593">
              {/* MVP */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300 bg-stone-100" data-id="element-1594">
                <div className="flex items-center justify-between mb-4" data-id="element-1595">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-900 font-medium" data-id="element-1596">
                    MVP
                  </p>
                  <p className="font-mono text-xs text-red-600" data-id="element-1597">Now</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1598">
                  Instant Infrastructure
                </p>
                <p className="text-sm text-stone-600" data-id="element-1599">
                  Quotes, holds, proposals, basic workflow
                </p>
              </div>

              {/* V1 */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-1600">
                <div className="flex items-center justify-between mb-4" data-id="element-1601">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1602">
                    V1
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1603">Q2 2026</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1604">
                  Closing the Loop
                </p>
                <p className="text-sm text-stone-600" data-id="element-1605">
                  Contracts, e-sign, payments, PMS integrations
                </p>
              </div>

              {/* V2 */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-1606">
                <div className="flex items-center justify-between mb-4" data-id="element-1607">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1608">
                    V2
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1609">Q4 2026</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1610">Intelligence</p>
                <p className="text-sm text-stone-600" data-id="element-1611">
                  Benchmarking, probability scoring, forecasting
                </p>
              </div>

              {/* V3 */}
              <div className="p-6 border-l-2 border-l-red-600 md:border-l-0 md:border-t-2 md:border-t-red-600" data-id="element-1612">
                <div className="flex items-center justify-between mb-4" data-id="element-1613">
                  <p className="font-mono text-xs uppercase tracking-widest text-red-600 font-medium" data-id="element-1614">
                    V3
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1615">2027</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1616">Rate Brain</p>
                <p className="text-sm text-stone-600" data-id="element-1617">
                  Aggregation + intelligence platform
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}